/**
 * The purpose of this module is to make anchor links work even though
 * angular inserts a slash after each hash character.
 */

/**
 * Scroll to an anchor link if the URL says to do so
 */
function scrollToAnchorIfShould(scrollInstantly = false) {
    const hash = window.location.hash;
    if (hash[0] === '#' && hash[1] === '/') {
        const anchorId = hash.substring(2);
        let anchorElement;
        try {
            anchorElement = document.querySelector('a#' + anchorId);
        } catch (e) {
            //We get here if its an invalid selector such as if hash contains 2 slashes
        }
        if (anchorElement) {
            anchorElement.scrollIntoView({
                behavior: (scrollInstantly ? 'auto' : 'smooth') as 'auto' | 'smooth',
                block: 'start'
            });
        }
    }
}

/**
 * This waits for the page to stop chaning its height before running the callback.
 * This is needed on pages that load 3rd party iframes that may change in size
 * while we are scrolling down, leaving us in the wrong place when the scrolling ends
 * This especially needed for firefox
 *
 * @param callback is called when page height stops changing
 * @param checkInterval how often to check the page height
 * @param minUnchangedCheckCount how many times the page height must be the same before running the callback
 */
function waitUntilPageHeightStopsChanging(checkInterval = 100, minUnchangedCheckCount = 10) {
    return new Promise<void>((resolve, reject) => {
        let checksSinceChanged = 0;
        let lastHeight = 0;
        const interval = setInterval(() => {
            if (document.body.clientHeight !== lastHeight) {
                checksSinceChanged = 0
            }
            lastHeight = document.body.clientHeight;
            if (checksSinceChanged > minUnchangedCheckCount) {
                clearInterval(interval);
                resolve();
            }
            checksSinceChanged++;
        }, checkInterval)
    })
}

/**
 * Is needed incase someone clicks an anchor link AGAIN when they are already on that hash
 *
 * @param {*} event
 */
function handleAClick(event) {
    let href = event.target.getAttribute('href'); //if target element is an a tag, great, use it
    if (!href) {
        //We wind up here if target element is not an a tag
        if(event.target.closest) {//IE11 doesn't have "closest" sometimes or something
            const aTag = event.target.closest('a');
            if (aTag) {
                // We wind up here if we found an a tag above the event target element
                href = aTag.getAttribute('href');
            }
        }
    }
    if (href && href.includes('#')) {
        scrollToAnchorIfShould(false);
    }
}

export default function initAngularAnchorFixer() {
    window.addEventListener('hashchange', () => {
        scrollToAnchorIfShould(false)
    });
    document.addEventListener('DOMContentLoaded', () => {
        waitUntilPageHeightStopsChanging().then(() => {
            scrollToAnchorIfShould(true); //Helps with firefox
        })
    });
    document.addEventListener('click', handleAClick);
}
